import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {EQOColor, EQOIcon, EQORadius, EQORebrandColor, EQORebrandIcon} from '@quickorder/angular-web-lib';
import {FileEntry} from '@app/core/models/fileEntry.model';
import {AuthService, UserType} from '@app/core/services/auth.service';
import {FileEntryService} from '@app/modules/shared/services/fileEntry.service';
import {Store} from '@ngrx/store';
import {IAppState} from '@app/core/store/state/app.state';
import {RemoveFileEntry} from '@app/core/store/actions/file-entry.actions';

@Component({
	selector: 'app-file-entry-edit',
	templateUrl: './file-entry-edit.component.html',
	styleUrls: ['./file-entry-edit.component.scss'],
})
export class FileEntryEditComponent implements OnInit {
	public EQORebrandIcon: typeof EQORebrandIcon = EQORebrandIcon;
	public EQORebrandColor: typeof EQORebrandColor = EQORebrandColor;

	@Input()
	public set fileEntries(fileEntries: FileEntry[]) {
		this.currentFileEntries = [];
		if (fileEntries) {
			fileEntries = [...new Set(fileEntries)];
			fileEntries.forEach((fileEntry: FileEntry) => {
				this.currentFileEntries.push(fileEntry);
			});
			this.emitFileIds();
		}
	}

	@Input() public edit: boolean;

	@Output() public fileIds = new EventEmitter();

	public currentFileEntries: FileEntry[] = [];

	constructor(
		private authService: AuthService,
		private fileEntryService: FileEntryService,
		private store: Store<IAppState>,
	) {
	}

	public ngOnInit(): void {
	}

	public emitFileIds(): void {
		this.fileIds.emit(this.currentFileEntries.map((value) => {
			return value.id;
		}));
	}

	public downloadFile(fileEntry: FileEntry): void {
		if (this.authService.userType === UserType.USER) {
			this.fileEntryService.downloadFile(fileEntry.id);
		} else {
			this.fileEntryService.downloadFilePunchUser(fileEntry.id);
		}
	}

	public removeFileEntry(fileEntry: FileEntry): void {
		this.store.dispatch(new RemoveFileEntry(fileEntry));

	}
}
